import styled from 'styled-components';

export default styled.div`
  height: 5px;
  width: calc(100% + 40px);
  background-color: var(--color-beige);
  margin-left: -20px;
  margin-bottom: 20px;
  margin-top: 50px;
`;
